<template>
    <div class="cate-container">
        <!-- <div class="cate-title">分类管理</div> -->
        <Search></Search>
        <Content></Content>
    </div>
</template>

<script>
import Search from './search';
import Content from './content';

export default {
    name: 'article',
    components: { Search, Content },

    data() {
        return {};
    },
    beforeDestroy() {
        this.$store.commit('mkt-content-article/clear');
    },
};
</script>
<style lang="less" scoped>
.cate-container {
    background: #fff;
}
.cate-title {
    padding: 20px 0 0 30px;
    font-size: 18px;
}
</style>
